import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepCatalog extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1 className="text--xxl-title l-margin-bottom--xl">Catalog: Resource Representations</h1>
				<h2 className="text--title l-margin-bottom">Item</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> no </td>
							<td> String</td>
							<td> Item's identification number in BrickLink catalog </td>
							<td> </td>
						</tr>
						<tr>
							<td> name </td>
							<td> String </td>
							<td> The name of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> type </td>
							<td> String </td>
							<td> The type of the item </td>
							<td>MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> category_id </td>
							<td> Integer </td>
							<td> The main category of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> alternate_no </td>
							<td> String </td>
							<td> Alternate item number </td>
							<td> <a href="http://www.bricklink.com/help.asp?helpID=599" target="_blank">Alternate item number</a> </td>
						</tr>
						<tr>
							<td> image_url </td>
							<td> String </td>
							<td> Image link for this item </td>
							<td> </td>
						</tr>
						<tr>
							<td> thumbnail_url </td>
							<td> String </td>
							<td> Image thumbnail link for this item </td>
							<td> </td>
						</tr>
						<tr>
							<td> weight </td>
							<td> Fixed Point Number </td>
							<td> The weight of the item in grams </td>
							<td> with 2 decimal places </td>
						</tr>
						<tr>
							<td> dim_x </td>
							<td> String </td>
							<td> Length of the item </td>
							<td> <a href="http://www.bricklink.com/help.asp?helpID=261" target="_blank">Item dimensions</a> with 2 decimal places </td>
						</tr>
						<tr>
							<td> dim_y </td>
							<td> String </td>
							<td> Width of the item </td>
							<td> <a href="http://www.bricklink.com/help.asp?helpID=261" target="_blank">Item dimensions</a> with 2 decimal places</td>
						</tr>
						<tr>
							<td> dim_z </td>
							<td> String </td>
							<td> Height of the item </td>
							<td> <a href="http://www.bricklink.com/help.asp?helpID=261" target="_blank">Item dimensions</a> with 2 decimal places</td>
						</tr>
						<tr>
							<td> year_released </td>
							<td> Integer </td>
							<td> Item year of release </td>
							<td> </td>
						</tr>
						<tr>
							<td> description </td>
							<td> String </td>
							<td> Short description for this item </td>
							<td> </td>
						</tr>
						<tr>
							<td> is_obsolete </td>
							<td> Boolean </td>
							<td> Indicates whether the item is obsolete </td>
							<td> </td>
						</tr>
						<tr>
							<td> language_code </td>
							<td> String </td>
							<td> Item language code </td>
							<td> <a href="https://www.bricklink.com/help.asp?helpID=2004" target="_blank">Item language</a> </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "no":"3305-1",
    "name":"World Team Player",
    "type":"SET",
    "image_url":"http://bltest.ubifun.com/SL/3305-1.jpg",
    "thumbnail_url":"http://bltest.ubifun.com/S/3305-1.gif",
    "weight":"3.92",
    "dim_x":"0.00",
    "dim_y":"0.00",
    "dim_z":"0.00",
    "year_released":1998,
    "is_obsolete":false,
    "category_id":473
}`}</Highlight>
				<h2>Superset Entry</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> The ID of the color of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[] </td>
							<td> List </td>
							<td> A list of the items that include the specified item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item </td>
							<td> Object </td>
							<td> An object representation of the super item that includes the specified item  </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item.no </td>
							<td> String</td>
							<td> Item's identification number in BrickLink catalog </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item.name </td>
							<td> String </td>
							<td> The name of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item.type </td>
							<td> String </td>
							<td> The type of the item </td>
							<td> MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> entries[].item.category_id </td>
							<td> Integer </td>
							<td> The main category of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].quantity </td>
							<td> Integer </td>
							<td> Indicates that how many specified items are included in this super item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].appear_as </td>
							<td> String </td>
							<td> Indicates how an entry in an inventory appears as </td>
							<td> A: Alternate, C: Counterpart, E: Extra, R: Regular </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "color_id":6,
    "entries": [ 
        {
            "item": {
                "no":"555-1",
                "name":"Hospital",
                "type":"SET",
                "categoryID":277
            },
            "quantity":1,
            "appears_as":"R" 
        },
        {
            "item": {
                "no":"363-1",
                "name":"Hospital with Figures",
                "type":"SET",
                "categoryID":277
            },
            "quantity":1,
            "appears_as":"R" 
        }
    ]
}`}</Highlight>
				<h2>Subset Entry</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> match_no </td>
							<td> Integer </td>
							<td> A identification number given to a matching group that consists of regular items and alternate items. </td>
							<td> 0 if there is no matching of alternative item </td>
						</tr>
						<tr>
							<td> entries[] </td>
							<td> List </td>
							<td> A list of the items included in the specified item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item </td>
							<td> Object </td>
							<td> An object representation of the item that is included in the specified item  </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item.no </td>
							<td> String</td>
							<td> Item's identification number in BrickLink catalog </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item.name </td>
							<td> String </td>
							<td> The name of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].item.type </td>
							<td> String </td>
							<td> The type of the item </td>
							<td> MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> entries[].item.category_id </td>
							<td> Integer </td>
							<td> The main category of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].color_id </td>
							<td> Integer </td>
							<td> The ID of the color of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].quantity </td>
							<td> Integer </td>
							<td> The number of items that are included in </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].extra_quantity </td>
							<td> Integer </td>
							<td> The number of items that are appear as "extra" item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].is_alternate </td>
							<td> Boolean </td>
							<td> Indicates that the item is appear as "alternate" item in this specified item </td>
							<td> </td>
						</tr>
						<tr>
							<td> entries[].is_counterpart </td>
							<td> Boolean </td>
							<td> Indicates that the item is appear as "counterpart" item in this specified item </td>
							<td> </td>
						</tr>						
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "match_no":1,
    "entries": [
        { 
            "item": {
                "no":"3001old",
                "name":"Brick 2 x 4 without Cross Supports",
                "type":"PART",
                "categoryID":5
            },
            "color_id":5,
            "quantity":1,
            "extra_quantity":0,
            "is_alternate":false,
            "is_counterpart":false
        },
        {
            "item": {
                "no":"3001old",
                "name":"Brick 2 x 4 without Cross Supports",
                "type":"PART",
                "categoryID":5
            },
            "color_id":7,
            "quantity":1,
            "extra_quantity":0,
            "is_alternate":true,
            "is_counterpart":false
        }
    ]
}`}</Highlight>
				<h2>Price Guide</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> item </td>
							<td> Object </td>
							<td> An object representation of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.no </td>
							<td> String </td>
							<td> Item's identification number in BL catalog</td>
							<td> </td>
						</tr>
						<tr>
							<td> item.type </td>
							<td> String </td>
							<td> The type of the item</td>
							<td> </td>
						</tr>
						<tr>
							<td> new_or_used </td>
							<td> String </td>
							<td> Indicates whether the price guide is for new or used </td>
							<td> N: New, U: Used </td>
						</tr>
						<tr>
							<td> currency_code </td>
							<td> String </td>
							<td> The currency code of the price </td>
							<td> </td>
						</tr>
						<tr>
							<td> min_price </td>
							<td> Fixed Point Number </td>
							<td> The lowest price of the item (in stock / that was sold for last 6 months ) </td>
							<td> </td>
						</tr>
						<tr>
							<td> max_price </td>
							<td> Fixed Point Number </td>
							<td> The highest price of the item (in stock / that was sold for last 6 months ) </td>
							<td> </td>
						</tr>
						<tr>
							<td> avg_price </td>
							<td> Fixed Point Number </td>
							<td> The average price of the item (in stock / that was sold for last 6 months )  </td>
							<td> </td>
						</tr>
						<tr>
							<td> qty_avg_price </td>
							<td> Fixed Point Number </td>
							<td> The average price of the item (in stock / that was sold for last 6 months ) by quantity </td>
							<td> </td>
						</tr>
						<tr>
							<td rowspan="2">unit_quantity </td>
							<td rowspan="2">Integer </td>
							<td> The number of times the item has been sold for last 6 months </td>
							<td rowspan="2"></td>
						</tr>
						<tr>
							<td> The number of store inventories that include the item </td>
						</tr>
						<tr>
							<td rowspan="2">total_quantity </td>
							<td rowspan="2">Integer </td>
							<td> The number of items has been sold for last 6 months </td>
							<td rowspan="2"></td>
						</tr>
						<tr>
							<td> The total number of the items in stock </td>
						</tr>
						<tr>
							<td> price_detail[] </td>
							<td> List </td>
							<td> A list of objects that represent the detailed information of the price </td>
							<td> see <a class="wiki-page" href="#Price-Detail">Price Detail</a> </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "item": {
        "no":"7644-1",
        "type":"SET" 
    },
    "new_or_used":"N",
    "currency_code":"USD",
    "min_price":"96.0440",
    "max_price":"695.9884",
    "avg_price":"162.3401",
    "qty_avg_price":"155.3686",
    "unit_quantity":298,
    "total_quantity":359,
    "price_detail": [

    ]
}`}</Highlight>
				<h2>Price Detail</h2>
				<h4>Resource</h4>
				<ul>
					<li>
						<p>Current Items for Sale:</p>
						<table className="l-margin-bottom--sm">
							<tbody>
								<tr>
									<th>Property name </th>
									<th>Value </th>
									<th>Description </th>
									<th>Note </th>
								</tr>
								<tr>
									<td> quantity </td>
									<td> Integer </td>
									<td> The number of the items in the store inventory </td>
									<td> </td>
								</tr>
								<tr>
									<td> qunatity </td>
									<td> <del>Integer</del> </td>
									<td> <del>The number of the items in the store inventory</del> </td>
									<td> To be deprecated. Typo. </td>
								</tr>
								<tr>
									<td> unit_price </td>
									<td> Fixed Point Number </td>
									<td> The original price of this item per sale unit </td>
									<td> </td>
								</tr>
								<tr>
									<td> shipping_available </td>
									<td> String </td>
									<td> Indicates whether or not the seller ships to your country(based on the user profile)  </td>
									<td> </td>
								</tr>
							</tbody>
						</table>
					</li>
					<li>
						<p>Last 6 Months Sales:</p>
						<table>
							<tbody>
								<tr>
									<th>Property name </th>
									<th>Value </th>
									<th>Description </th>
									<th>Note </th>
								</tr>
								<tr>
									<td> quantity </td>
									<td> Integer </td>
									<td> The number of the items in the store inventory </td>
									<td> </td>
								</tr>
								<tr>
									<td> unit_price </td>
									<td> Fixed Point Number </td>
									<td> The original price of this item per sale unit </td>
									<td> </td>
								</tr>
								<tr>
									<td> seller_country_code </td>
									<td> String </td>
									<td> The country code of the seller's location </td>
									<td><a href="http://en.wikipedia.org/wiki/ISO_3166-1_alpha-2" target="_blank">ISO 3166-1 alpha-2</a> (exception: UK instead of GB) </td>
								</tr>
								<tr>
									<td> buyer_country_code </td>
									<td> String </td>
									<td> The country code of the buyer's location </td>
									<td><a href="http://en.wikipedia.org/wiki/ISO_3166-1_alpha-2" target="_blank">ISO 3166-1 alpha-2</a> (exception: UK instead of GB) </td>
								</tr>
								<tr>
									<td> date_ordered </td>
									<td> Timestamp </td>
									<td> The time the order was created </td>
									<td> </td>
								</tr>
							</tbody>
						</table>
					</li>
				</ul>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "quantity":2,
    "qunatity":2,
    "unit_price":"96.0440",
    "shipping_available":true
}`}</Highlight>
				<Highlight className="json">{`{
    "quantity":1,
    "unit_price":"98.2618",
    "seller_country_code":"CZ",
    "buyer_country_code":"HK",
    "date_ordered":"2013-12-30T14:59:01.850Z" 
}`}</Highlight>
				<h2>Known Color</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> Color ID </td>
							<td> </td>
						</tr>
						<tr>
							<td> quantity </td>
							<td> Integer </td>
							<td> The quantity of items in that color </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "color_id":"1",
    "quantity":"10" 
}`}</Highlight>
			</section>
		);
	}
}